//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    vehicle: {
      type: Object,
      default () {
        return {}
      }
    },
    forkliftTrack: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      initialized: false,
      opened: false
    }
  },
  computed: {
    notMobile: function () {
      return !this.mobile
    }
  },
  watch: {
    vehicle: function () {
      this.prepareVehicleImage()
    }
  },
  created: function () {
    this.prepareVehicleImage()
  },
  methods: {
    getVehicleCardUrl: function () {
      return this.$d_getUrlObjectCard(this.vehicle.id, 'vehicle')
    },
    prepareVehicleImage: function () {
      if (this.vehicle && this.vehicle.imageIds && this.vehicle.imageIds.length != 0) {
        this.vehicle.imageUrl = '/service/delta/document/thumbnail/' + this.vehicle.imageIds[0] + '/78/104'
      }

      this.initialized = true
    }
  }
}

